const LEFT_POINTS =
  '14.1944444 18.3611111 9.64583333 24.6458333 6 24.6458333 12.3888889 15.8611111 6.17361111 7.35416667 9.81944444 7.35416667 14.1944444 13.4305556 16 15.9305556';
const RIGHT_POINTS =
  '24.1944444 18.3611111 19.6458333 24.6458333 16 24.6458333 22.3888889 15.8611111 16.1736111 7.35416667 19.8194444 7.35416667 24.1944444 13.4305556 26 15.9305556';

export function LogoMark({
  size = 24,
  prism = false,
}: {
  size?: number;
  prism?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      fillRule="evenodd"
      role="img"
      aria-label="Exis"
      style={{ display: 'block' }}
    >
      {prism && (
        <defs>
          <linearGradient
            id="exisPrismGradient"
            x1="36.4820927%"
            y1="6.75018206%"
            x2="36.4820927%"
            y2="94.24069%"
          >
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#00FF88" />
          </linearGradient>
        </defs>
      )}
      <polygon fill="currentColor" points={LEFT_POINTS} />
      <polygon
        fill={prism ? 'url(#exisPrismGradient)' : 'currentColor'}
        transform="translate(21, 16) scale(-1, 1) translate(-21, -16)"
        points={RIGHT_POINTS}
      />
    </svg>
  );
}
